import axios from "axios";

const authApi = axios.create({
  // baseURL: "http://localhost:8000/api/v1/",
  baseURL: "https://api-staging.pristinepv.co.uk/api/v1/",
  headers: {
    "Content-Type": "application/json",
  },
});

const AuthApi = () => {
  /**
   * Request account deletion OTP
   */
  const requestAccountDeletion = async (email) => {
    try {
      const response = await authApi.post("auth/account/delete/request", {
        email,
      });

      return response.data;
    } catch (error) {
      console.error("Request account deletion API error:", error);

      throw error;
    }
  };

  /**
   * Verify deletion OTP and delete account
   */
  const verifyAccountDeletion = async (email, otp) => {
    try {
      const response = await authApi.post("auth/account/delete/verify", {
        email,
        otp,
      });

      return response.data;
    } catch (error) {
      console.error("Verify account deletion API error:", error);

      throw error;
    }
  };

  /**
   * Request account recovery OTP
   */
  const requestAccountRecovery = async (email) => {
    try {
      const response = await authApi.post("auth/account/recover/request", {
        email,
      });

      return response.data;
    } catch (error) {
      console.error("Request account recovery API error:", error);

      throw error;
    }
  };

  /**
   * Verify recovery OTP and restore account
   */
  const verifyAccountRecovery = async (email, otp) => {
    try {
      const response = await authApi.post("auth/account/recover/verify", {
        email,
        otp,
      });

      return response.data;
    } catch (error) {
      console.error("Verify account recovery API error:", error);

      throw error;
    }
  };

  return {
    requestAccountDeletion,
    verifyAccountDeletion,
    requestAccountRecovery,
    verifyAccountRecovery,
  };
};

export default AuthApi;
